module.exports = __webpack_public_path__ + "img/exclamation-info-icon.87984bcd.png";